import { render, staticRenderFns } from "./UpdateMember.vue?vue&type=template&id=5334c36c&"
import script from "./UpdateMember.vue?vue&type=script&lang=js&"
export * from "./UpdateMember.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMember.vue?vue&type=style&index=0&id=5334c36c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports